import React, { FunctionComponent } from 'react'

import { Box, Text } from '@theme-ui/components'

import { round } from 'lodash'
import { useTranslation } from 'react-i18next'

import { baseColors, makeTransition } from '@fairhq/common'

import { Tooltip } from '../components/Tooltip'
import { whiteColorBgChecker } from '../constants'
import { VisualizationItemValueProps, VisualizationTypeProps } from '../types'

export const RowStackVisualizationItemValue: FunctionComponent<
  VisualizationTypeProps<VisualizationItemValueProps>
> = ({ item, isScoreBy10 }) => {
  const { t } = useTranslation()
  const label = item.value ? (
    (isScoreBy10 && round(item.value / 10, 1)) || `${round(item.value)}%`
  ) : (
    <Box as="span" sx={{ opacity: 0 }}>
      {t('na')}
    </Box>
  )
  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: '0 4px 4px 0',
        bg: item.color ?? baseColors.backgroundPrimaryAction,
        border: '1px solid',
        borderColor: item.borderColor ?? baseColors.borderPrimary,
        borderBottom: 'none',
        transition: makeTransition('opacity'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '42px',
        width: '100%',
        maxWidth: `${item.value > 100 ? 100 : item.value}%`,
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          left: '-12px',
          bottom: '0',
          top: '0',
          width: '12px',
          bg: item.value ? item.color : undefined,
          zIndex: -1,
        },
        '&:hover': { '.tooltip': { opacity: 1 } },
      }}
    >
      <Text
        as="div"
        sx={{
          fontWeight: 600,
          color:
            item.value > 0 && item.key !== 'benchmark'
              ? (whiteColorBgChecker.includes(item.color) &&
                  baseColors.contentContent) ||
                'grey400'
              : 'grey500',
          right:
            item.value === 0 || item.key === 'benchmark' ? '-48px' : undefined,
          position: 'absolute',
        }}
      >
        {label}
      </Text>
      <Tooltip tooltip={item.tooltip} isHorizontal />
    </Box>
  )
}
